import React, { useContext, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { DataContext } from '../Context/DataContext';
import styles from './CarDetails.module.css';
import { FaUserFriends, FaGasPump, FaTachometerAlt, FaCogs, FaArrowLeft, FaCalendarAlt, FaMapMarkerAlt, FaUser, FaEnvelope, FaPhone } from 'react-icons/fa';
import toast, { Toaster } from 'react-hot-toast';

const CarDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { getCarById, loading, setSelectedCar, selectedCar } = useContext(DataContext);
  const [car, setCar] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // 🔹 حالة لكل حقل
  const [formData, setFormData] = useState({
    pickupDate: '',
    returnDate: '',
    pickupLocation: '',
    fullName: '',
    email: '',
    phone: ''
  });

  useEffect(() => {
    if (!loading) {
      const foundCar = getCarById(parseInt(id));
      if (foundCar) {
        setCar(foundCar);
        setSelectedCar(foundCar);
      } else navigate('/');
    }
  }, [loading, id, getCarById, navigate, setSelectedCar]);

  if (loading || !car) return <p>Loading...</p>;
  const { name, price, seats, fuelType, miles, transmission, image } = car;
  if (!selectedCar) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleBookingSubmit = async (e) => {
    e.preventDefault();

    // 🔹 تحقق من تعبئة كل الحقول
    const emptyField = Object.values(formData).some(val => val.trim() === '');
    if (emptyField) {
      toast.error('Please fill out all fields!');
      return;
    }

    setIsSubmitting(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 1500)); // محاكاة إرسال البيانات
      toast.success('Your booking request has been sent!');
      // 🔹 هنا ممكن مسح الفورم لو حبيت
      setFormData({
        pickupDate: '',
        returnDate: '',
        pickupLocation: '',
        fullName: '',
        email: '',
        phone: ''
      });
    } catch (err) {
      toast.error('Something went wrong!');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.containerWrapper}>
      <Toaster position="top-right" reverseOrder={false} />

      <div className={styles.backArrow} onClick={() => navigate(-1)}>
        <FaArrowLeft size={25} />
      </div>

      <div className={styles.container}>
        <div className={styles.left}>
          <img src={image || 'https://via.placeholder.com/800x500?text=Car+Image'} alt={name} />
          <h2>{name}</h2>
          <p className={styles.price}>₹{price} / day</p>

          <div className={styles.specs}>
            <div className={styles.spec}><FaUserFriends size={20} /> {seats} Seats</div>
            <div className={styles.spec}><FaGasPump size={20} /> {fuelType}</div>
            <div className={styles.spec}><FaTachometerAlt size={20} /> {miles} MPG</div>
            <div className={styles.spec}><FaCogs size={20} /> {transmission}</div>
          </div>

          <div className={styles.aboutBox}>
            <h3>About this car</h3>
            <p>{selectedCar.details?.description}</p>
          </div>
        </div>

        <div className={styles.right}>
          <h3>Reserve <span>Your Drive</span></h3>
          <form className={styles.bookingForm} onSubmit={handleBookingSubmit}>
            <label>
              <FaCalendarAlt style={{ marginRight: "5px" }} /> Pickup Date
              <input type="date" name="pickupDate" value={formData.pickupDate} onChange={handleInputChange} />
            </label>

            <label>
              <FaCalendarAlt style={{ marginRight: "5px" }} /> Return Date
              <input type="date" name="returnDate" value={formData.returnDate} onChange={handleInputChange} />
            </label>

            <label>
              <FaMapMarkerAlt style={{ marginRight: "5px" }} /> Pickup Location
              <input type="text" name="pickupLocation" placeholder="Enter pickup location" value={formData.pickupLocation} onChange={handleInputChange} />
            </label>

            <label>
              <FaUser style={{ marginRight: "5px" }} /> Full Name
              <input type="text" name="fullName" placeholder="Your full name" value={formData.fullName} onChange={handleInputChange} />
            </label>

            <label>
              <FaEnvelope style={{ marginRight: "5px" }} /> Email Address
              <input type="email" name="email" placeholder="Your email" value={formData.email} onChange={handleInputChange} />
            </label>

            <label>
              <FaPhone style={{ marginRight: "5px" }} /> Phone Number
              <input type="tel" name="phone" placeholder="Your phone number" value={formData.phone} onChange={handleInputChange} />
            </label>

            <div className={styles.total}>
              <span>Rate/day</span><span>₹{price}</span>
              <span>Total</span><span>₹{price}</span>
            </div>

            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Loading...' : 'Confirm Booking'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CarDetails;
